import { useEffect, useState } from "react";
import {
  FaBuilding,
  FaChalkboardTeacher,
  FaUsers,
  FaGraduationCap,
  FaSchool,
} from "react-icons/fa";
import "./CareerOrientationSection.css";

const statsData = [
  { value: 15, label: "Chi nhánh", suffix: "", icon: <FaBuilding /> },
  { value: 169, label: "Phòng học", suffix: "", icon: <FaSchool /> },
  {
    value: 269,
    label: "Giảng viên",
    suffix: "",
    icon: <FaChalkboardTeacher />,
  },
  {
    value: 13317,
    label: "Lớp khai giảng",
    suffix: "",
    icon: <FaGraduationCap />,
  },
  { value: 200083, label: "Học viên", suffix: "+", icon: <FaUsers /> },
];

const CareerOrientationSection = () => {
  const [counts, setCounts] = useState(statsData.map(() => 0));

  useEffect(() => {
    const duration = 1500;
    const startTime = performance.now();

    const animate = (time) => {
      const progress = Math.min((time - startTime) / duration, 1);
      setCounts(statsData.map((stat) => Math.floor(stat.value * progress)));
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, []);

  return (
    <section className="career-orientation">
      <div className="career-orientation__container">
        <div className="career-orientation__logo">
          <img
            src="/logo-design24.webp"
            alt="Design24"
          />
        </div>
        <h1 className="career-orientation__title">Học viện Design24</h1>

        <div className="career-orientation__content">
          <p className="career-orientation__description">
            Học viên Design24 được lĩnh hội giá trị nghề và năng lực nghiệp vụ
            chất lượng bằng phương pháp đào tạo sát thực tiễn. Design24 không
            ngừng phát triển các chương trình đào tạo mới cũng như xây dựng cơ
            sở vật chất hiện đại nhằm mang đến cho học viên môi trường học tập
            lý tưởng. Mỗi năm có hơn 20.000 học viên trên khắp các tỉnh thành
            được đào tạo thuộc khối ngành F&B, Chăm sóc sắc đẹp, Digital
            Marketing, Học Viện Âm Nhạc Á Âu, Media Production,… Design24 khẳng
            định vị thế hàng đầu Việt Nam về đào tạo và cung ứng nhân sự chất
            lượng, quản lý cao cấp cho các doanh nghiệp nổi tiếng trong nước và
            quốc tế.
          </p>

          <div className="career-orientation__stats">
            {statsData.map((stat, i) => (
              <div
                key={i}
                className="career-orientation__stat"
              >
                <div className="career-orientation__number">
                  {counts[i].toLocaleString()}
                  {stat.suffix}
                </div>
                <div className="career-orientation__icon">{stat.icon}</div>
                <div className="career-orientation__label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerOrientationSection;
